import script from "./AddImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddImage.vue?vue&type=script&setup=true&lang=ts"

import "./AddImage.scss?vue&type=style&index=0&id=40c5171a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c5171a"]])

export default __exports__